var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-mobile-nav__trigger",class:{ 'is-active': _vm.state.mobileNavActive },attrs:{"style-max-size":"medium"},on:{"click":function($event){return _vm.toggle()}}},[_c('div',{staticClass:"icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }